import React from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import block from "../../assets/blocked.png";

const DeniedScreen = () => {
  const History = useHistory();

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center px-4"
      style={{ height: "80vh" }}
    >
      <img src={block} alt="" height={200} />

      <div className="my-2">
        <div className="fw-bold text-center">Maaf,</div>
        <div className="text-center">
          Anda tidak memiliki akses untuk melihat pengiriman ini.
        </div>
        <Button
          type="button"
          variant="primary"
          className="pe-4 ps-4 rounded w-100 fs-7 mt-2"
          onClick={() => History.push("/")}
        >
          Kembali ke menu utama
        </Button>
      </div>
    </div>
  );
};

export default DeniedScreen;
